(() => {
  const sections = document.querySelectorAll('.lookbook-archive');

  const FADE_ACTIVE_SELECTOR =
    '.acci-nav .acci-nav__item:hover, .acci-nav .acci-nav__item:focus-within, ' +
    '.acci-shop__filter-wrap:hover, .acci-shop__filter-wrap:focus-within, .acci-shop__filter-wrap.is-open, ' +
    '.acci-header__right:hover, .acci-header__right:focus-within';

  sections.forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-lookbook-card]'));
    const filterButtons = Array.from(section.querySelectorAll('[data-lookbook-filter]'));
    const filterWrap = section.querySelector('.acci-shop__filter-wrap');
    const filterTrigger = section.querySelector('.acci-shop__filter-trigger');
    const titleNode = section.querySelector('.acci-shop__title');
    const defaultTitle = (titleNode?.dataset.defaultTitle || '').trim();
    let activeFilter = 'all';
    let lockUntilReenter = false;
    let leftFilterAfterSelection = false;

    if (!cards.length || !filterButtons.length) return;

    const isDesktopHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const enableGlobalFade = () => document.body.classList.add('fade-global');
    const disableGlobalFadeWhenInactive = () => {
      if (document.getElementById('acci-cart-drawer')?.classList.contains('is-open')) return;
      if (!isDesktopHover()) {
        if (!document.querySelector('.acci-shop__filter-wrap.is-open, .lookbook-viewer__credits-wrap.is-open')) {
          document.body.classList.remove('fade-global');
        }
        return;
      }
      if (!document.querySelector(FADE_ACTIVE_SELECTOR)) {
        document.body.classList.remove('fade-global');
      }
    };

    const closeFilterMenu = () => {
      if (!filterWrap) return;
      filterWrap.classList.remove('is-open');
      if (filterTrigger) {
        filterTrigger.setAttribute('aria-expanded', 'false');
      }
    };

    const setTitle = (nextTitle) => {
      if (!titleNode) return;
      titleNode.innerHTML = nextTitle || defaultTitle;
    };

    const updateTitleVisibility = () => {
      if (!titleNode) return;
      const showTitle = activeFilter === 'all';
      titleNode.hidden = !showTitle;
      if (!showTitle) {
        setTitle(defaultTitle);
      }
    };

    const clearHoverState = () => {
      if (window.innerWidth > 768 && activeFilter === 'all') {
        setTitle(defaultTitle);
      }
    };

    const setFilter = (nextFilter) => {
      activeFilter = nextFilter;
      filterButtons.forEach((button) => {
        const isActive = button.dataset.lookbookFilter === nextFilter;
        button.classList.toggle('underline-dots-static', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach((card) => {
        const isVisible = nextFilter === 'all' || card.dataset.collectionHandle === nextFilter;
        card.classList.toggle('is-hidden', !isVisible);
      });

      clearHoverState();
      updateTitleVisibility();
    };

    const forceCloseFilterMenu = () => {
      if (!filterWrap) return;
      filterWrap.classList.add('is-selected-closed');
      filterWrap.classList.remove('is-open');
      if (filterTrigger) {
        filterTrigger.setAttribute('aria-expanded', 'false');
      }
      lockUntilReenter = true;
      leftFilterAfterSelection = false;
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        forceCloseFilterMenu();
        setFilter(button.dataset.lookbookFilter || 'all');
        document.body.classList.remove('fade-global');
        disableGlobalFadeWhenInactive();
      });
    });

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        if (window.innerWidth > 768 && activeFilter === 'all') {
          setTitle(card.dataset.collectionTitle || defaultTitle);
        }
      });
      card.addEventListener('mouseleave', clearHoverState);
      card.addEventListener('focusin', () => {
        if (window.innerWidth > 768 && activeFilter === 'all') {
          setTitle(card.dataset.collectionTitle || defaultTitle);
        }
      });
      card.addEventListener('focusout', (event) => {
        if (!card.contains(event.relatedTarget)) {
          clearHoverState();
        }
      });
    });

    section.addEventListener('mouseleave', clearHoverState);

    if (filterWrap && filterTrigger) {
      filterTrigger.setAttribute('aria-expanded', 'false');

      filterWrap.addEventListener('mouseenter', () => {
        if (isDesktopHover()) enableGlobalFade();
        if (!lockUntilReenter || !leftFilterAfterSelection) return;
        filterWrap.classList.remove('is-selected-closed');
        lockUntilReenter = false;
        leftFilterAfterSelection = false;
      });

      filterWrap.addEventListener('mouseleave', () => {
        if (isDesktopHover()) {
          if (filterWrap.contains(document.activeElement) && typeof document.activeElement?.blur === 'function') {
            document.activeElement.blur();
          }
          closeFilterMenu();
          disableGlobalFadeWhenInactive();
        }
        if (!lockUntilReenter) return;
        leftFilterAfterSelection = true;
      });

      filterWrap.addEventListener('focusin', () => {
        if (isDesktopHover()) enableGlobalFade();
      });

      filterWrap.addEventListener('focusout', () => {
        if (isDesktopHover()) requestAnimationFrame(disableGlobalFadeWhenInactive);
      });

      filterTrigger.addEventListener('click', (event) => {
        if (window.innerWidth > 768 && lockUntilReenter && !leftFilterAfterSelection) {
          return;
        }
        filterWrap.classList.remove('is-selected-closed');
        lockUntilReenter = false;
        leftFilterAfterSelection = false;
        if (window.innerWidth <= 768) {
          event.preventDefault();
          const isOpen = filterWrap.classList.toggle('is-open');
          filterTrigger.setAttribute('aria-expanded', String(isOpen));
          if (isOpen) {
            enableGlobalFade();
          } else {
            document.body.classList.remove('fade-global');
            disableGlobalFadeWhenInactive();
          }
        }
      });

      document.addEventListener(
        'click',
        (event) => {
          if (window.innerWidth > 768) return;
          if (!filterWrap.classList.contains('is-open')) return;
          if (filterWrap.contains(event.target)) return;

          event.preventDefault();
          event.stopPropagation();
          closeFilterMenu();
          document.body.classList.remove('fade-global');
          disableGlobalFadeWhenInactive();
        },
        true
      );
    }

    setFilter('all');
  });
})();
